import PasswordInput from '../components/PasswordInput';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import SifreSifirlaPage from './SifreSifirlaPage';

const RECAPTCHA_SITE_KEY = '6LdICsMsAAAAADHlDIfcI35cznYw3ZpWZuv81w2d';

const GirisPage = ({ sayfaDegistir }) => {
  const { girisYap, oturumMesaj } = useAuth();
  const [sekme, setSekme] = useState('personel');
  const [form, setForm] = useState({ email: '', sifre: '' });
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);
  const [captchaToken, setCaptchaToken] = useState('');
  const [sifreGoster, setSifreGoster] = useState(false);
  const [sifreIstekBasari, setSifreIstekBasari] = useState('');
  const [sifreIstekEmail, setSifreIstekEmail] = useState('');
  const [sifreToken, setSifreToken] = useState(null);
  const captchaRef = useRef(null);
  const widgetId = useRef(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('sifre-sifirla');
    if (token) setSifreToken(token);
  }, []);

  useEffect(() => {
    if (sekme !== 'aday') return;
    const loadCaptcha = () => {
      if (captchaRef.current && window.grecaptcha && widgetId.current === null) {
        widgetId.current = window.grecaptcha.render(captchaRef.current, {
          sitekey: RECAPTCHA_SITE_KEY,
          callback: (token) => setCaptchaToken(token),
          'expired-callback': () => setCaptchaToken('')
        });
      }
    };
    if (window.grecaptcha) {
      loadCaptcha();
    } else {
      window.onRecaptchaLoad = loadCaptcha;
      if (!document.querySelector('script[src*="recaptcha"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    }
  }, [sekme]);

  useEffect(() => {
    setCaptchaToken('');
    if (sekme === 'personel' && window.grecaptcha && widgetId.current !== null) {
      try { window.grecaptcha.reset(widgetId.current); widgetId.current = null; } catch(e) {}
    }
  }, [sekme]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHata(''); setYukleniyor(true);
    try {
      if (sekme === 'personel') {
        await girisYap(form.email, form.sifre, null);
      } else {
        const res = await axios.post('/api/adaylar/giris', { ...form, captchaToken });
        const { token, kullanici: k } = res.data;
        localStorage.setItem('token', token);
        localStorage.setItem('kullanici', JSON.stringify(k));
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        window.location.reload();
      }
    } catch(err) {
      setHata(err.response?.data?.hata || 'Giris basarisiz.');
      setCaptchaToken('');
      if (window.grecaptcha && widgetId.current !== null) {
        try { window.grecaptcha.reset(widgetId.current); } catch(e) {}
      }
    } finally { setYukleniyor(false); }
  };

  const handleSifreIstek = async (e) => {
    e.preventDefault();
    setYukleniyor(true); setSifreIstekBasari(''); setHata('');
    try {
      await axios.post('/api/sifre/istek', { email: sifreIstekEmail });
      setSifreIstekBasari('Kayitli bir hesap varsa sifirlama baglantisi gonderildi.');
    } catch(err) {
      setHata(err.response?.data?.hata || 'Hata olustu.');
    } finally { setYukleniyor(false); }
  };

  if (sifreToken) {
    return <SifreSifirlaPage token={sifreToken} geriDon={() => {
      setSifreToken(null);
      window.history.replaceState({}, '', '/');
      widgetId.current = null;
      setCaptchaToken('');
    }} />;
  }

  return (
    <div className="giris-wrap">
      <div className="giris-kart">
        <div className="giris-logo">
          <div className="ikon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1a56db" strokeWidth="1.5">
              <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
          </div>
          <h1>Valure HR</h1>
        </div>

        {!sifreGoster ? (
          <>
            <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', marginBottom: '1.5rem' }}>
              <button type="button" onClick={() => { setSekme('personel'); setHata(''); }}
                style={{ flex: 1, padding: '0.6rem', border: 'none', background: 'none', cursor: 'pointer', fontSize: '14px', fontWeight: sekme === 'personel' ? '600' : '400', color: sekme === 'personel' ? 'var(--mavi)' : 'var(--yazi-ikincil)', borderBottom: sekme === 'personel' ? '2px solid var(--mavi)' : '2px solid transparent' }}>
                Personel Girisi
              </button>
              <button type="button" onClick={() => { setSekme('aday'); setHata(''); }}
                style={{ flex: 1, padding: '0.6rem', border: 'none', background: 'none', cursor: 'pointer', fontSize: '14px', fontWeight: sekme === 'aday' ? '600' : '400', color: sekme === 'aday' ? 'var(--mavi)' : 'var(--yazi-ikincil)', borderBottom: sekme === 'aday' ? '2px solid var(--mavi)' : '2px solid transparent' }}>
                Aday Girisi
              </button>
            </div>

            {oturumMesaj && <div className="alert alert-info">{oturumMesaj}</div>}
            {hata && <div className="alert alert-error">{hata}</div>}

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div className="form-group">
                <label>E-posta</label>
                <input type="email" placeholder="ornek@firma.com" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required autoComplete="email" />
              </div>
              <div className="form-group">
                <label>Sifre</label>
                <PasswordInput value={form.sifre} onChange={e => setForm({ ...form, sifre: e.target.value })} placeholder="••••••••" required />
              </div>

              {sekme === 'aday' && (
                <div>
                  <div ref={captchaRef}></div>
                  {!captchaToken && <div style={{ fontSize: '12px', color: 'var(--kirmizi)', marginTop: '4px' }}>Lutfen robot dogrulamasini tamamlayin.</div>}
                </div>
              )}

              <button type="submit" className="btn btn-primary"
                disabled={yukleniyor || (sekme === 'aday' && !captchaToken)}
                style={{ width: '100%', padding: '0.75rem' }}>
                {yukleniyor ? 'Giris yapiliyor...' : 'Giris Yap'}
              </button>
            </form>

            <div style={{ textAlign: 'center', marginTop: '1rem' }}>
              <button type="button" style={{ background: 'none', border: 'none', color: 'var(--mavi)', cursor: 'pointer', fontSize: '13px' }} onClick={() => { setSifreGoster(true); setHata(''); }}>
                Sifremi Unuttum
              </button>
            </div>

            {sekme === 'aday' && (
              <p style={{ marginTop: '0.75rem', fontSize: '12px', color: 'var(--yazi-ikincil)', textAlign: 'center' }}>
                Hesabiniz yok mu? <button type="button" style={{ background: 'none', border: 'none', color: 'var(--mavi)', cursor: 'pointer', fontSize: '12px' }} onClick={() => sayfaDegistir && sayfaDegistir('aday-kayit')}>Kayit Olun</button>
              </p>
            )}
            {sekme === 'personel' && (
              <p style={{ marginTop: '0.75rem', fontSize: '12px', color: 'var(--yazi-ikincil)', textAlign: 'center' }}>Hesabiniz yoksa sistem yoneticinizle iletisime gecin.</p>
            )}
          </>
        ) : (
          <>
            <h2 style={{ fontSize: '18px', marginBottom: '0.5rem' }}>Sifremi Unuttum</h2>
            <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)', marginBottom: '1.5rem' }}>Mail adresinizi girin, sifirlama baglantisi gondeRelim.</p>
            {hata && <div className="alert alert-error" style={{ marginBottom: '1rem' }}>{hata}</div>}
            {sifreIstekBasari && <div className="alert alert-success" style={{ marginBottom: '1rem' }}>{sifreIstekBasari}</div>}
            <form onSubmit={handleSifreIstek} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div className="form-group">
                <label>E-posta</label>
                <input type="email" placeholder="ornek@firma.com" value={sifreIstekEmail} onChange={e => setSifreIstekEmail(e.target.value)} required />
              </div>
              <button type="submit" className="btn btn-primary" disabled={yukleniyor} style={{ width: '100%', padding: '0.75rem' }}>
                {yukleniyor ? 'Gonderiliyor...' : 'Sifirlama Baglantisi Gonder'}
              </button>
            </form>
            <div style={{ textAlign: 'center', marginTop: '1rem' }}>
              <button type="button" style={{ background: 'none', border: 'none', color: 'var(--mavi)', cursor: 'pointer', fontSize: '13px' }} onClick={() => { setSifreGoster(false); setHata(''); setSifreIstekBasari(''); }}>
                ← Giris Sayfasina Don
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default GirisPage;
